import { GraphqQlApi as api } from '../api/api'

export class LifeCycleCore {

  constructor(store) {
    this.store = store
  }

  async CallInitAppHook(args) {
    return await api.onInitApp(args)
  }

  async CallAfterSignInHook(args) {
    const newArgs = { ...args, routeQuery: JSON.stringify(args.routeQuery || {}), routeParams: JSON.stringify(args.routeParams || {}) }
    const response = await api.onAfterSignIn(newArgs)
    if (response.result) {
      const userRoleActivity = response.activities.find((x) => x.Type === 'SetUserRoleActivity')
      if (userRoleActivity) {
        this.store.commit('SET_USER_ROLE', userRoleActivity.NewRole)
      }
    }
    return response
  }

  async CallBeforePageEnterHook(args) {
    const newArgs = { ...args, routeQuery: JSON.stringify(args.routeQuery || {}), routeParams: JSON.stringify(args.routeParams || {}) }
    return await api.OnBeforePageEnter(newArgs)
  }
}
